// extracted by mini-css-extract-plugin
export default {"container":"background-header_container__QrDsA","overlay":"background-header_overlay__VYvjI","image":"background-header_image__PjxQ+","title":"background-header_title__K+URg"};